/**
 * Convert array of objects to CSV string
 */
export const toCSV = (rows: Array<Record<string, unknown>>): string => {
  if (!rows || !rows.length) return "";

  const keys = Object.keys(rows[0]);
  const header = keys.join(",");

  const lines = rows.map((r) =>
    keys
      .map((k) => {
        const v = (r as Record<string, unknown>)[k];
        const sv = v == null ? "" : String(v);
        const escaped = sv.replace(/"/g, '""');
        if (/[",\n]/.test(escaped)) return `"${escaped}"`;
        return escaped;
      })
      .join(",")
  );

  return [header, ...lines].join("\n");
};

/**
 * Trigger download of text content as a file
 */
export const downloadFile = (
  filename: string,
  content: string,
  mime = "text/csv;charset=utf-8;"
) => {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

/**
 * Export data as CSV file
 */
export const exportCSV = (rows: Array<Record<string, unknown>>, filename = "export.csv") => {
  if (!rows || !rows.length) {
    downloadFile(filename, "", "text/csv;charset=utf-8;");
    return;
  }

  const csv = toCSV(rows);

  // Prepend UTF-8 BOM so Excel on Windows recognizes UTF-8 encoding
  const bomCsv = "\uFEFF" + csv;
  downloadFile(filename, bomCsv, "text/csv;charset=utf-8;");
};
